enum EquipmentTypes {
  NONE = 'NONE',
  DUMBBELLS = 'DUMBBELLS',
  BENCH = 'BENCH',
  STEP = 'STEP',
  RESISTANCE_BAND = 'RESISTANCE_BAND',
  STABILITY_BALL = 'STABILITY_BALL',
  RESISTANCE_BAND_LOW_ANCHOR = 'RESISTANCE_BAND_LOW_ANCHOR',
  KETTLEBELL = 'KETTLEBELL',
  BAND = 'BAND',
  MINI_BANDS = 'MINI_BANDS',
  GLIDERS = 'GLIDERS',
  FOAM_ROLLER = 'FOAM_ROLLER',
  CHAIR = 'CHAIR',
  MEDICINE_BALL = 'MEDICINE_BALL',
}

export const equipmentKeys = Object.keys(EquipmentTypes) as EquipmentTypes[];

export default EquipmentTypes;
